(function () {
  "use strict";

  var gallerySelector = "[data-zonveer-product-gallery]";
  var thumbnailSelector = "[data-zonveer-product-thumbnail]";
  var productSectionSelector = ".product-section-wrapper";

  function keepThumbnailVisible(list, thumbnail) {
    var listRect = list.getBoundingClientRect();
    var thumbnailRect = thumbnail.getBoundingClientRect();
    var thumbnailCenter =
      thumbnailRect.left - listRect.left + list.scrollLeft + thumbnailRect.width / 2;
    var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
    var targetScroll = Math.min(
      maxScroll,
      Math.max(0, thumbnailCenter - list.clientWidth / 2)
    );

    list.scrollTo({ left: targetScroll, behavior: "smooth" });
  }

  function connectZoomCounter(gallery) {
    var zoomSlider = gallery.querySelector("[data-zoom-slider]");

    if (!zoomSlider || zoomSlider.dataset.zonveerCounterConnected === "true") {
      return;
    }

    var counter = document.createElement("div");
    counter.className = "zv-zoom-counter";
    counter.setAttribute("aria-live", "polite");
    counter.setAttribute("aria-atomic", "true");
    zoomSlider.appendChild(counter);

    var attempts = 0;

    function waitForZoomSwiper() {
      var zoomSwiper = zoomSlider.swiper;

      if (!zoomSwiper) {
        attempts += 1;

        if (attempts < 240) {
          window.requestAnimationFrame(waitForZoomSwiper);
        }

        return;
      }

      zoomSlider.dataset.zonveerCounterConnected = "true";

      function updateCounter() {
        var total = zoomSlider.querySelectorAll(
          ".zoom-slider__slide:not(.swiper-slide-duplicate)"
        ).length;
        var current = Number.isFinite(zoomSwiper.realIndex)
          ? zoomSwiper.realIndex + 1
          : zoomSwiper.activeIndex + 1;

        counter.textContent = current + " / " + total;
      }

      zoomSwiper.on("slideChange", updateCounter);
      updateCounter();
    }

    waitForZoomSwiper();
  }

  function connectGallery(gallery) {
    if (gallery.dataset.zonveerGalleryConnected === "true") {
      return;
    }

    connectZoomCounter(gallery);

    var slider = gallery.querySelector("[data-js-product-media-slider]");
    var thumbnailList = gallery.querySelector("[data-zonveer-product-thumbnails]");
    var thumbnails = Array.prototype.slice.call(
      gallery.querySelectorAll(thumbnailSelector)
    );

    if (!slider || !thumbnailList || thumbnails.length < 2) {
      return;
    }

    var attempts = 0;

    function waitForSwiper() {
      var swiper = slider.swiper;

      if (!swiper) {
        attempts += 1;

        if (attempts < 240) {
          window.requestAnimationFrame(waitForSwiper);
        }

        return;
      }

      gallery.dataset.zonveerGalleryConnected = "true";

      function setActiveThumbnail(index) {
        var activeThumbnail = thumbnails[index];

        thumbnails.forEach(function (thumbnail, thumbnailIndex) {
          var isActive = thumbnailIndex === index;
          thumbnail.classList.toggle("is-active", isActive);
          thumbnail.setAttribute("aria-current", isActive ? "true" : "false");
        });

        if (activeThumbnail) {
          keepThumbnailVisible(thumbnailList, activeThumbnail);
        }
      }

      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener("click", function () {
          var index = Number(thumbnail.dataset.slideIndex);

          if (!Number.isNaN(index)) {
            swiper.slideTo(index);
          }
        });
      });

      swiper.on("slideChange", function () {
        setActiveThumbnail(swiper.activeIndex);
      });

      setActiveThumbnail(swiper.activeIndex || 0);
    }

    waitForSwiper();
  }

  function initializeGalleries(root) {
    var galleries = [];

    if (root.matches && root.matches(gallerySelector)) {
      galleries.push(root);
    }

    if (root.querySelectorAll) {
      galleries = galleries.concat(
        Array.prototype.slice.call(root.querySelectorAll(gallerySelector))
      );
    }

    galleries.forEach(connectGallery);
  }

  function parseProductInfoConfig(section) {
    var configNode = section.querySelector("[data-zonveer-product-info-config]");

    if (!configNode) {
      return null;
    }

    try {
      return JSON.parse(configNode.textContent);
    } catch (error) {
      return null;
    }
  }

  function createSubtitle(titleWrapper, subtitle) {
    if (!subtitle || titleWrapper.querySelector(".zv-product-subtitle")) {
      return;
    }

    var subtitleNode = document.createElement("p");
    subtitleNode.className = "zv-product-subtitle";
    subtitleNode.textContent = subtitle;
    titleWrapper.appendChild(subtitleNode);
  }

  function createHighlightsAccordion(description, config) {
    if (!description || description.dataset.zonveerHighlights === "true") {
      return;
    }

    var content = document.createElement("div");
    var contentInner = document.createElement("div");
    var button = document.createElement("button");
    var label = document.createElement("span");
    var icon = document.createElement("span");
    var isOpen = config.highlightsOpen !== false;
    var contentId = "ZonveerHighlights-" + Math.random().toString(36).slice(2, 10);

    content.className = "zv-product-highlights__content";
    content.id = contentId;
    contentInner.className = "zv-product-highlights__content-inner";

    while (description.firstChild) {
      contentInner.appendChild(description.firstChild);
    }

    content.appendChild(contentInner);

    label.textContent = config.highlightsLabel || "Why You'll Love It";
    icon.className = "zv-product-highlights__icon";
    icon.setAttribute("aria-hidden", "true");

    button.type = "button";
    button.className = "zv-product-highlights__toggle";
    button.setAttribute("aria-controls", contentId);
    button.setAttribute("aria-expanded", isOpen ? "true" : "false");
    button.appendChild(label);
    button.appendChild(icon);

    description.classList.add("zv-product-highlights");
    description.classList.toggle("is-open", isOpen);
    description.appendChild(button);
    description.appendChild(content);
    description.dataset.zonveerHighlights = "true";

    button.addEventListener("click", function () {
      var nextState = !description.classList.contains("is-open");
      description.classList.toggle("is-open", nextState);
      button.setAttribute("aria-expanded", nextState ? "true" : "false");
    });
  }

  function getMoneyPrefix(priceText) {
    var match = (priceText || "").trim().match(/^[^0-9-]+/);
    return match ? match[0] : "$";
  }

  function readMoneyValue(node) {
    if (!node) {
      return 0;
    }

    var amount = Number(node.getAttribute("data-amount"));

    if (Number.isFinite(amount) && amount > 0) {
      return amount / 100;
    }

    return Number((node.textContent || "").replace(/[^0-9.]/g, "")) || 0;
  }

  function updateSavingsBadge(priceBlock, showSavingsBadge) {
    if (!priceBlock || !showSavingsBadge) {
      return;
    }

    var salePrice = priceBlock.querySelector(".price-item--sale[data-product-price], .price-item--sale");
    var comparePrice = priceBlock.querySelector("[data-price-old], .price__sale .price-item--regular");
    var saleValue = readMoneyValue(salePrice);
    var compareValue = readMoneyValue(comparePrice);
    var savings = compareValue - saleValue;
    var badge = priceBlock.querySelector(".zv-savings-pill");

    if (!(savings > 0)) {
      if (badge) {
        badge.remove();
      }
      return;
    }

    if (!badge) {
      badge = document.createElement("span");
      badge.className = "zv-savings-pill";
      var saleContainer = priceBlock.querySelector(".price__sale") || priceBlock;
      saleContainer.appendChild(badge);
    }

    var roundedSavings = Math.round(savings * 100) / 100;
    var formattedSavings = roundedSavings % 1 === 0
      ? roundedSavings.toFixed(0)
      : roundedSavings.toFixed(2);
    var badgeText = getMoneyPrefix(salePrice ? salePrice.textContent : "$") + formattedSavings + " OFF";

    if (badge.textContent !== badgeText) {
      badge.textContent = badgeText;
    }
  }

  function reorderProductInfo(section, titleWrapper, description, priceBlock) {
    var formBlock = section.querySelector(".product-form .product-form__block");

    if (!formBlock || !priceBlock) {
      return;
    }

    var options = formBlock.querySelector(".product-options");
    formBlock.insertBefore(priceBlock, formBlock.firstChild);

    if (options) {
      priceBlock.insertAdjacentElement("afterend", options);
      options.insertAdjacentElement("afterend", description);
    } else if (description) {
      priceBlock.insertAdjacentElement("afterend", description);
    }

    if (titleWrapper) {
      titleWrapper.closest(".product-form__block").classList.add("zv-product-intro-block");
    }
  }

  function connectProductInfo(section) {
    if (section.dataset.zonveerProductInfoConnected === "true") {
      return;
    }

    var config = parseProductInfoConfig(section);

    if (!config || config.enabled === false) {
      return;
    }

    var titleWrapper = section.querySelector(".product-title-wrapper");
    var description = section.querySelector(".product-description-wrapper");
    var priceBlock = section.querySelector(".product-price-quantity");

    if (!titleWrapper) {
      return;
    }

    section.dataset.zonveerProductInfoConnected = "true";
    section.classList.add("zv-product-info-reference");

    createSubtitle(titleWrapper, config.subtitle);
    reorderProductInfo(section, titleWrapper, description, priceBlock);
    createHighlightsAccordion(description, config);
    updateSavingsBadge(priceBlock, config.showSavingsBadge !== false);

    if (priceBlock && config.showSavingsBadge !== false) {
      var priceRefreshQueued = false;
      var priceObserver = new MutationObserver(function () {
        if (priceRefreshQueued) {
          return;
        }

        priceRefreshQueued = true;
        window.requestAnimationFrame(function () {
          priceRefreshQueued = false;
          updateSavingsBadge(priceBlock, true);
        });
      });

      priceObserver.observe(priceBlock, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["data-amount"]
      });
    }
  }

  function initializeProductInfo(root) {
    var sections = [];

    if (root.matches && root.matches(productSectionSelector)) {
      sections.push(root);
    }

    if (root.querySelectorAll) {
      sections = sections.concat(
        Array.prototype.slice.call(root.querySelectorAll(productSectionSelector))
      );
    }

    sections.forEach(connectProductInfo);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initializeGalleries(document);
      initializeProductInfo(document);
    });
  } else {
    initializeGalleries(document);
    initializeProductInfo(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeGalleries(event.target);
    initializeProductInfo(event.target);
  });
})();